import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import AdminNavbar from "../components/AdminNavbar";
import { motion, AnimatePresence } from "framer-motion";

const AddStores = () => {
  const [storeid, setStoreid] = useState("");
  const [storeName, setStoreName] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    const token = localStorage.getItem("accessToken");

    try {
      const response = await axios.post(
        "/admin/addstore",
        { storeid, storename: storeName },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (response.status === 201) {
        navigate("/admin/store");
      }
    } catch (err) {
      if (err.response) {
        if (err.response.status === 409) {
          setError(err.response.data.message || "Store ID already exists.");
        } else {
          setError(err.response.data.message || "Failed to add store.");
        }
      } else {
        setError("Network error. Please check your connection.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <AdminNavbar />
      <motion.div
        style={styles.container}
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <motion.div
          style={styles.formContainer}
          initial={{ scale: 0.95, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ delay: 0.2, duration: 0.5 }}
        >
          <motion.h1
            style={styles.title}
            initial={{ y: -20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.3, duration: 0.4 }}
          >
            Add Store
          </motion.h1>

          <AnimatePresence>
            {error && (
              <motion.p
                style={styles.error}
                initial={{ opacity: 0, y: -10 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -10 }}
              >
                {error}
              </motion.p>
            )}
          </AnimatePresence>

          <form onSubmit={handleSubmit} style={styles.form}>
            <motion.div
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.4 }}
            >
              <label style={styles.label}>Store ID:</label>
              <motion.input
                whileFocus={{ scale: 1.02, borderColor: "#007bff" }}
                type="text"
                value={storeid}
                onChange={(e) => setStoreid(e.target.value)}
                placeholder="Enter store ID"
                style={styles.input}
                required
              />
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.5 }}
            >
              <label style={styles.label}>Store Name:</label>
              <motion.input
                whileFocus={{ scale: 1.02, borderColor: "#007bff" }}
                type="text"
                value={storeName}
                onChange={(e) => setStoreName(e.target.value)}
                placeholder="Enter store name"
                style={styles.input}
                required
              />
            </motion.div>

            <motion.button
              type="submit"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              style={{
                ...styles.button,
                backgroundColor: loading ? "#6c757d" : "#007bff",
              }}
              disabled={loading}
            >
              {loading ? "Adding..." : "Add Store"}
            </motion.button>
          </form>
        </motion.div>
      </motion.div>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    backgroundColor: "#f4f4f4",
    minHeight: "100vh",
    paddingTop: "40px",
  },
  formContainer: {
    backgroundColor: "white",
    padding: "30px",
    borderRadius: "12px",
    boxShadow: "0 8px 24px rgba(0, 0, 0, 0.15)",
    width: "400px",
    textAlign: "center",
  },
  title: {
    fontSize: "26px",
    fontWeight: "bold",
    marginBottom: "20px",
  },
  form: {
    display: "flex",
    flexDirection: "column",
  },
  label: {
    fontSize: "15px",
    fontWeight: "600",
    marginBottom: "5px",
    textAlign: "left",
  },
  input: {
    padding: "10px",
    fontSize: "14px",
    border: "1px solid #ccc",
    borderRadius: "6px",
    marginBottom: "15px",
    outline: "none",
    transition: "border-color 0.2s",
    width: "100%",
  },
  button: {
    backgroundColor: "#007bff",
    color: "white",
    border: "none",
    padding: "12px",
    fontSize: "16px",
    borderRadius: "6px",
    cursor: "pointer",
    transition: "background-color 0.2s",
  },
  error: {
    color: "red",
    fontSize: "14px",
    marginBottom: "10px",
  },
};

export default AddStores;
